import { Component, Input, inject } from "@angular/core";
import { UiService } from "@app/services/cdk/ui.service";
import { SelfEnrollmentService } from "@app/services/self-enrollment/self-enrollment.service";

@Component({
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.component.html",
  styleUrls: ["./auth-layout.component.scss"],
})
export class AuthLayoutComponent {
  private _ui: UiService = inject(UiService);
  private _selfEnrollmentService: SelfEnrollmentService = inject(
    SelfEnrollmentService
  );

  @Input() hero: string;
  @Input() signUp = false;

  appLogo: string;

  constructor() {
    this._ui.getAppLogo$().subscribe(logo => {
      this.appLogo = logo;
    });
  }

  goToHelp() {
    return this._selfEnrollmentService.goToHelp();
  }
}
